import React, { useEffect } from 'react';
import { FaTimes, FaShieldAlt } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import css from './WelcomeModal.module.css';
import { FaHome, FaCheckCircle, FaIdCard } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { RxLoop } from 'react-icons/rx';

const WelcomeModal = ({ userName, onClose }) => {
  const history = useHistory();
  const displayName = userName ? userName.split(' ')[0] : 'there';

  const handleCTA = () => {
    const whatsappURL = "https://wa.me/918459591563?text=Hi%2C%20I%20am%20looking%20to%20speak%20with%20a%20Purf%20Expert.";

    onClose();
    window.open(whatsappURL, "_blank"); // opens in new tab
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className={css.overlay}>
      <div className={css.container}>

        {/* Close Button */}
        <button className={css.closeButton} onClick={onClose}>
          <FaTimes />
        </button>

        {/* Left Section */}
        <div className={css.left}>
          <img
            src="/static/ratings/welcomeLeftImg.jpeg"
            alt="Happy pet"
            className={css.image}
          />

          <div className={css.badge}>
            <div className={css.shieldIcon}>
              <img src="/static/listingcard/shield-icon.png" alt="Shield Icon" />
              <div className={css.shieldTooltip}>
                Boarding and Daycare with this provider is covered under Purfurry 5K Pet Protection Plan.
              </div>
            </div>
            <span>5K Protection</span>
          </div>
        </div>

        {/* Right Section */}
        <div className={css.right}>

          {/* Logo */}
          {/* <img
            src="/static/mainassets/logo.png"
            alt="Purfurry Logo"
            className={css.logo}
          /> */}

          <h1 className={css.title}>Welcome, {displayName}!</h1>

          <p className={css.subtitle}>
            Ready to find a second home for your pet while you are away?
          </p>

          <p className={css.text}>
            All Purf Boarders:
          </p>
          <ul className={css.list}>
            <li>
              <FaHome className={css.icon} />
              Provide cage free home boarding
            </li>
            <li>
              <FaCheckCircle className={css.icon} />
              Are rigorously vetted for quality care
            </li>
            <li>
              <FaIdCard className={css.icon} />
              Are background verified through Aadhar KYC
            </li>
          </ul>

          <p className={css.footer}>
            Travel guilt free, your pet feels at home with Purfurry.
          </p>

          <p className={css.purpleText}>
            <RxLoop />&nbsp; 100% Repeat Rate!
          </p>

          <div className={css.ctaButtons}>
            <button className={css.cta} onClick={onClose}>
              Hosts near me
            </button>

            <button
              className={`${css.cta} ${css.whatsappCta}`}
              onClick={handleCTA}
            >
              <FaWhatsapp className={css.ctaIcon} />
              Talk to Purf Expert
            </button>
          </div>
          <div className={css.ratingsImg}>
            <a href="https://www.trustpilot.com/review/purfurry.com" target="_blank" rel="noopener noreferrer">
              <img src="/static/ratings/trustpilot.jpeg" alt="Purfurry Ratings" className={css.ratingImageTrustpilot} />
            </a>
            <a href="https://maps.app.goo.gl/AWx1rMdsZNFU1aqEA?g_st=ac" target="_blank" rel="noopener noreferrer">
              <img src="/static/ratings/google.jpeg" alt="Purfurry Ratings" className={css.ratingImageGoogle} />
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;